import {
  BooleanInput,
  ReferenceInput,
  ListButton,
  SelectInput,
  useGetIdentity,
  useRecordContext,
  FormDataConsumer,
  SelectArrayInput,
  ReferenceArrayInput,
  ChipField,
  ArrayField,
  CheckboxGroupInput,
  SingleFieldList,
  DateInput,
} from "react-admin";
import { Buyer } from "../types";
import {
  Stack,
  Typography,
  Box,
  Card,
  CardContent,
  Tooltip,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export function ScmConfigsInputs() {
  const { identity } = useGetIdentity();
  const record = useRecordContext<Buyer>();
  const optionScmConfigsRenderer = (choice: any) =>
    `${choice.id}. ${choice.nome_reduzido}`;
  const { setValue } = useFormContext(); // Hook do react-hook-form

  return (
    <Stack sx={{ width: "100%" }}>
      <Card>
        <form>
          <CardContent>
            <Box display={{ md: "block", lg: "flex" }}>
              <Box flex={1} mr={{ sm: "0.5em" }}>
                <Typography variant="h6" gutterBottom>
                  Dados Cadastrais
                </Typography>
              </Box>
              <Box mr={{ sm: "0.5em" }}>
                <ListButton />
              </Box>
            </Box>
            <Box mt={2} />
            <Box display={{ md: "block", lg: "flex" }}>
              <Box mr={{ xs: 0, sm: "0.5em" }}>
                <BooleanInput source="proj" label="Possui Projeção" fullWidth />
              </Box>
              <Box mr={{ xs: 0, sm: "0.5em" }}>
                <BooleanInput
                  source="suprim"
                  label="Recebe Suprimento"
                  resource="scmconfigs"
                />
              </Box>
              <Box mr={{ xs: 0, sm: "0.5em" }}>
                <BooleanInput
                  source="compra"
                  label="Compra"
                  resource="scmconfigs"
                />
              </Box>
            </Box>
            <Box display={{ md: "block", lg: "flex" }}>
              <Box mr={{ xs: 0, sm: "0.5em" }}>
                <CheckboxGroupInput
                  source="dias_semana"
                  choices={[
                    { id: 1, name: "Segunda-Feira" },
                    { id: 2, name: "Terça-Feira" },
                    { id: 3, name: "Quarta-Feira" },
                    { id: 4, name: "Quinta-Feira" },
                    { id: 5, name: "Sexta-Feira" },
                    { id: 6, name: "Sábado" },
                    { id: 7, name: "Domingo" },
                  ]}
                  fullWidth
                />
              </Box>
            </Box>
            <Box mt={2} />
            <Box display={{ md: "block", lg: "flex" }}>
              <Box mr={{ xs: 0, sm: "0.5em" }}>
                <BooleanInput
                  source="acesso_restrito"
                  label="Acesso Restrito"
                />
              </Box>
              <Box mr={{ xs: 0, sm: "0.5em" }}>
                <ArrayField source="ips">
                  <SingleFieldList linkType="">
                    <ChipField source="ip" size="small" />
                  </SingleFieldList>
                </ArrayField>
              </Box>
            </Box>
            <Box display={{ md: "block", lg: "flex" }}>
              <Box mr={{ sm: "0.2em" }}>
                <BooleanInput
                  source="copiar_curva"
                  label="Copiar curva de outra loja"
                  sx={{ marginTop: "0.5em" }}
                  onChange={(e) => {
                    if (!e.target.checked) {
                      setValue("id_emp_curva", null, { shouldDirty: true });
                      setValue("validade_emp_curva", null, {
                        shouldDirty: true,
                      });
                    }
                  }}
                />
              </Box>
              <Box mr={{ sm: "2.5em" }}>
                <Tooltip
                  title="Essa ação de cópia da curva de uma loja para outra será processada automaticamente durante a madrugada do dia seguinte."
                  placement="top"
                  slotProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "#fff",
                        color: "#555",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "#fff",
                      },
                    },
                  }}
                >
                  <HelpOutlineIcon
                    sx={{ marginTop: "1em", fontSize: "small" }}
                  />
                </Tooltip>
              </Box>
              <Box>
                <FormDataConsumer>
                  {({ formData }: any) => (
                    <>
                      {formData.copiar_curva && (
                        <Box display={{ md: "block", lg: "flex" }}>
                          <Box mr={{ xs: 0, sm: "0.5em" }}>
                            <ReferenceInput
                              source="id_emp_curva"
                              reference="scmconfigs"
                              perPage={100}
                              sort={{ field: "id", order: "ASC" }}
                              InputLabelProps={{ shrink: true }}
                              label="Curva Empresa"
                              style={{ width: "300px" }}
                            >
                              <SelectInput
                                optionText={optionScmConfigsRenderer}
                                label="Curva Empresa"
                              />
                            </ReferenceInput>
                          </Box>
                          <Box>
                            <DateInput
                              source="validade_emp_curva"
                              label="Validade Curva"
                            />
                          </Box>
                        </Box>
                      )}
                    </>
                  )}
                </FormDataConsumer>
              </Box>
            </Box>
            <Box mt={2} />
            <Box mr={{ xs: 0, sm: "0.5em" }}>
              <ReferenceArrayInput
                source="tags_nd"
                reference="producttags"
                perPage={1000}
                sort={{ field: "nome_tag", order: "ASC" }}
                resource="scmconfigs"
                // fullWidth
                resettable
                label="Não Distribuir"
                style={{ width: "30%" }}
              >
                <SelectArrayInput
                  optionText="nome_tag"
                  label="Não Distribuir"
                  style={{ width: "30%" }}
                />
              </ReferenceArrayInput>
            </Box>
          </CardContent>
        </form>
      </Card>
    </Stack>
  );
}
